<div class="tooltip-card">
  <div class="tooltip-content">
    <ng-container *ngFor="let item of data; let i = index">
      <div class="tooltip-item">
        <div class="brand-info">
          <div class="color-dot" [style.background-color]="item.color"></div>
          <span class="brand-name">{{ item.brand }}</span>
          <span class="impressions" *ngIf="item.impressions">
            ({{ item.impressions }})
          </span>
        </div>
        <div class="value">{{ item.value }}</div>
      </div>
      <div class="divider" *ngIf="i === 0"></div>
    </ng-container>
  </div>
</div>